/*
* LegalDocumentsActions.js
* Copyright (c) Harman International Industries, Incorporated, 2024 - 2025
* All rights reserved.
*/
import APIManager from '../../ApiManager/ApiManager';
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";
import { FETCH_LEGAL_LOCALE_DOCS_DETAILS_REQUEST,FETCH_LEGAL_LOCALE_DOCS_DETAILS_SUCCESS,FETCH_LEGAL_LOCALE_DOCS_DETAILS_FAILURE,FETCH_LEGAL_DOCUMENT_INFOS_REQUEST,FETCH_LEGAL_DOCUMENT_INFOS_SUCCESS,FETCH_LEGAL_DOCUMENT_INFOS_FAILURE,UPDATE_LEGAL_DOCUMENT_INFO_REQUEST,UPDATE_LEGAL_DOCUMENT_INFO_SUCCESS,UPDATE_LEGAL_DOCUMENT_INFO_FAILURE, FETCH_OEM_LEGAL_INFO_REQUEST, FETCH_OEM_LEGAL_INFO_SUCCESS, FETCH_OEM_LEGAL_INFO_FAILURE} from './LegalocaleDocumentsTypes';

export const fetchLegalLocaleDocsDetailsRequest = () => {
    return {
      type: FETCH_LEGAL_LOCALE_DOCS_DETAILS_REQUEST,
    };
  };

  export const fetchLegalLocaleDocsDetailsSuccess = (legallocaleDocsData) => {
    return {
      type: FETCH_LEGAL_LOCALE_DOCS_DETAILS_SUCCESS,
      payload: legallocaleDocsData,
    };
  };

  export const fetchLegalLocaleDocsDetailsFailure = (error) => {
    return {
      type: FETCH_LEGAL_LOCALE_DOCS_DETAILS_FAILURE,
      payload: error,
    };
  };

  export const fetchLegalDocumentInfos =()=>{
    return {
      type: FETCH_LEGAL_DOCUMENT_INFOS_REQUEST,
    }
  }

  export const fetchLegalDocumentInfosSuccess = (legalDocumentInfos) => {
    return {
      type: FETCH_LEGAL_DOCUMENT_INFOS_SUCCESS,
      payload: legalDocumentInfos,
    };
  };

  export const fetchLegalDocumentInfosFailure = (error) => {
    return {
      type: FETCH_LEGAL_DOCUMENT_INFOS_FAILURE,
      payload: error,
    };
  };
  export const updateLegalDocumentInfoRequest = () => {
    return {
      type: UPDATE_LEGAL_DOCUMENT_INFO_REQUEST,
    };
  };  
  export const updateLegalDocumentInfoSuccess=()=>{
    return {  
      type: UPDATE_LEGAL_DOCUMENT_INFO_SUCCESS,
    }
  }
  export const updateLegalDocumentInfoFailure=()=>{
    return {  
      type: UPDATE_LEGAL_DOCUMENT_INFO_FAILURE,
    }
  }

  export const fetchLegalInfoRequest =()=>{
    return {
      type: FETCH_OEM_LEGAL_INFO_REQUEST
    }
  }

   export const fetchLegalInfoSuccess =(legalInfo)=>{
    return {
      type: FETCH_OEM_LEGAL_INFO_SUCCESS,
      payload: legalInfo,
    }
  }

   export const fetchLegalInfoFailure =(error)=>{
    return {
      type: FETCH_OEM_LEGAL_INFO_FAILURE,
      payload: error,
    }
  }

  

  export const fetchLegalLocaleDocsDetails = () => {
    return async function (dispatch) {
      dispatch(fetchLegalLocaleDocsDetailsRequest());
      try {
        const data = await APIManager.getOemAdminLocales();
        dispatch(fetchLegalLocaleDocsDetailsSuccess(data));
      } catch (error) {
        dispatch(fetchLegalLocaleDocsDetailsFailure(error));
        dispatch(commonError(error, FETCH_LEGAL_LOCALE_DOCS_DETAILS_FAILURE));
      }
    };
  };

  export const fetchLegalDocumentInfosDetails = () => {
    return async function (dispatch) {
      dispatch(fetchLegalDocumentInfos());
      try {
        const data = await APIManager.getOemAdminLegalDocumentInfos();
        dispatch(fetchLegalDocumentInfosSuccess(data));
      } catch (error) {
        dispatch(fetchLegalDocumentInfosFailure(error));
        dispatch(commonError(error, FETCH_LEGAL_DOCUMENT_INFOS_FAILURE));
      }
    };
  };

  export const patchLegalDocumentInfos =(payload, lang)=>{
    return async function (dispatch) {
      dispatch(updateLegalDocumentInfoRequest());
      try {
        await APIManager.patchOemAdminLegalDocumentInfos(payload, lang);
        dispatch(updateLegalDocumentInfoSuccess());
      } catch (error) {
        dispatch(updateLegalDocumentInfoFailure());
        dispatch(commonError(error, UPDATE_LEGAL_DOCUMENT_INFO_FAILURE));
      }
    };
  }

  export const fetchOemLegalInfo=()=>{
    return async function (dispatch) {
      dispatch(fetchLegalInfoRequest());
      try {
        const data = await APIManager.getOemAdminLegalInfos();
        dispatch(fetchLegalInfoSuccess(data));
      } catch (error) {
        dispatch(fetchLegalInfoFailure(error));
        dispatch(commonError(error, FETCH_OEM_LEGAL_INFO_FAILURE));
      }
    };
  }

  export const commonError=(error,errorType)=>{
    return({
      type:COMMON_ERROR,
      payload:{
        message:error.message,
        errorType:errorType
      }
    })
  }
  

